/* eslint-disable @typescript-eslint/no-unused-vars */
'use client'
import * as X from "@/ui";
import { links } from "@/config";

import JobsImage from "@/assets/about-us-jobs.svg";
import { useAboutUsPage } from "@/providers/strapi/content/types/singleTypes/about-us-page";
import React from "react";
import ReactMarkdown from "react-markdown";


// const data = {
//   jobs: {
//     title: {
//       en: <>Join <strong>Us</strong></>,
//       fr: <>Rejoignez-<strong>nous</strong></>,
//     },

//     text: {
//       en: <>We’re always looking for new talent to strenghten our team!Think we’re a good match? <strong>Don’t wait — get in touch!</strong></>,
//       fr: <>Nous sommes toujours à la recherche de talents pour compléter notre équipe{X.Nbsp}! <strong>Si vous pensez qu’il y a un match, n’hésitez plus et contactez-nous{X.Nbsp}!</strong></>,
//     },

//     cta: {
//       en: "Apply now",
//       fr: "Postulez",
//     },
//   },
// };


export function JoinUsSection(_props: X.PageProps) {
  return (
    <section id="join" className={X.clsx("scroll-mt-[120px] relative my-10 xl:mt-22")}>
      <Mobile />
      <Desktop />
    </section>
  );
}


function Mobile() {
  const tr = X.useTranslator();
  const content = useAboutUsPage('joinUsCard');
  return (
    <div className={X.clsx(
      X.mobileOnly(),
      "w-full bg-yellow px-mobile-margin py-8 ",
      "flex flex-col gap-4 items-start"
    )}>
      {/* <h3 className="text-[36px] [&_strong]:font-medium">
        {tr(data.jobs.title)}
      </h3> */}
      <ReactMarkdown components={{
        p: ({ ...props }) => <h3 {...props} className="text-[36px] [&_strong]:font-medium" />
      }}>
        {content.title}
      </ReactMarkdown>
      <ReactMarkdown components={{
        p: ({ ...props }) => <h3 {...props} className="text-[16px] [&_strong]:font-semibold" />
      }}>
        {content.content}
      </ReactMarkdown>
      {/* <p className="text-[16px] [&_strong]:font-semibold">
        {tr(data.jobs.text)}

      </p> */}
      <X.Image src={JobsImage} alt="Jobs" className="-mt-10 -mb-5 w-full h-auto scale-130" />
      <X.Button secondary lg
        // exitHref={tr(links.jobs)}
        exitHref={content.jobLink}
        // label={tr(data.jobs.cta)}
        label={content.cta}
      />
    </div>
  );
}


function Desktop() {
  const tr = X.useTranslator();
  const content = useAboutUsPage('joinUsCard');
  return (
    <div className={X.clsx(
      X.desktopOnly("flex"), 'flex-col  justify-end pt-5 overflow-hidden -mt-10')}>


      <div className={X.clsx(
        X.desktopOnly("flex"),
        "max-w-content mx-auto px-12 py-10 rounded-xl bg-yellow min-h-[335px] w-full",
        "flex-row gap-20 relative"
      )}>
        <div className="flex flex-col gap-4 justify-between items-start w-[40%]">
          {/* <h3 className="text-[48px] [&_strong]:font-medium">{tr(data.jobs.title)}</h3> */}
          <ReactMarkdown components={{
            p: ({ ...props }) => <h3 {...props} className="text-[48px] [&_strong]:font-medium" />
          }}>
            {content.title}
          </ReactMarkdown>
          <ReactMarkdown components={{
            p: ({ ...props }) => <p {...props} className="text-[20px] [&_strong]:font-semibold leading-[28px] mb-2" />
          }}>
            {content.content}
          </ReactMarkdown>
          {/* <p className="text-[20px] [&_strong]:font-semibold leading-[28px] mb-2">
           {tr(data.jobs.text)}

        </p> */}
          <X.Button secondary lg
            // exitHref={tr(links.jobs)}
            exitHref={content.jobLink}
            // label={tr(data.jobs.cta)}
            label={content.cta}
          />
        </div>

        <X.Image
          src={JobsImage}
          alt="Jobs"
          className="absolute -right-[50px] -top-[171px] h-[550px] w-auto"
        />
      </div>
    </div>
  );
}
